<template>
	<!-- 分页器组件 -->
	<div class="pagination-container">
		<el-pagination
			background
			:hide-on-single-page="totalPage < 2 "
			layout="prev, pager, next"
			@current-change="handleCurrentChange"
			:page-count="totalPage"
            :current-page="currentPage"
		></el-pagination>
	</div>
</template>
<script>
export default {
	props: {
		totalPage: {
			type: [String, Number],
			default: 1
        },
        currentPage: {
			type: [Number],
			default: 1
		}
	},
	data() {
		return {};
	},
	methods: {
		handleCurrentChange(val) {
			this.$emit("current-page", val);
		}
	}
};
</script>
<style lang="scss" scoped>
.pagination-container/deep/ {
	display: flex;
	justify-content: flex-end;
	margin-top: 36px;
	cursor: pointer;
	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background: url("../assets/each-page-bg.png") center center no-repeat;
		block-size: 32px 32px;
	}
	.el-pager li,
	.el-pagination button {
		width: 32px;
		height: 32px;
		border-radius: 2px;
		border: 1px solid rgba(0, 0, 0, 0.15);
	}
	.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #58bca5;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
        color: #ffffff;
    }
}
</style>
